import { FC } from 'react';
import { ICON_COLLECTION } from 'assets/media/icons';
import { Icon } from 'common/components';
import HighlightedText from 'common/components/custom/highlighted-text/HighlightedText';

import './FilterList.scss';
import { EntityActions } from 'common/enums';

type FilterListProps = {
    name: string;
    path: string;
    searchVal: string;
    isDataEditorPreviewDisabled: boolean;
    onDetailsClick: (rowData: any) => void;
    onDeleteClick: (rowData: any) => void;
    onEditClick: (rowData: any) => void;
};

const FilterList: FC<FilterListProps> = ({
    name,
    path,
    searchVal,
    isDataEditorPreviewDisabled,
    onDetailsClick,
    onDeleteClick,
    onEditClick
}: FilterListProps) => {
    return (
        <div className="filter-list-container">
            <div className="filter-content">
                <div className="filter-text">
                    <HighlightedText text={name} highlight={searchVal} />
                </div>
                <div className="filter-breadcrumb" title={path}>
                    {path}
                </div>
            </div>
            <div className="filter-icon details">
                <Icon
                    src={ICON_COLLECTION.IC_Info}
                    onClick={onDetailsClick}
                    title={EntityActions.Details}
                />
            </div>
            <div className="filter-icon">
                <Icon
                    className="filter-edit-icon"
                    src={ICON_COLLECTION.IC_Edit}
                    onClick={onEditClick}
                    title={EntityActions.Edit}
                />
                <Icon
                    className="filter-delete-icon"
                    src={ICON_COLLECTION.IC_Delete}
                    onClick={onDeleteClick}
                    title={EntityActions.Delete}
                />
            </div>
        </div>
    );
};

export default FilterList;
